import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { Finding } from '../api/types';
import { formatDate, themeLabel } from '../lib/format';
import { EvidenceTallyLine } from './Evidence';
import { StatusBadge } from './StatusBadge';

export function findingPath(id: string): string {
  return `/findings/${encodeURIComponent(id)}`;
}

export function FindingCard({
  finding,
  projectTitle,
  headingLevel = 3,
  select,
}: {
  finding: Finding;
  projectTitle?: string;
  headingLevel?: 2 | 3 | 4;
  /** Optional selection control rendered beside the card (collections, comparison, exports). */
  select?: ReactNode;
}) {
  const Heading = headingLevel === 2 ? 'h2' : headingLevel === 3 ? 'h3' : 'h4';
  return (
    <article className={`finding-card finding-card--${finding.status}`}>
      {select !== undefined && <div className="finding-card__select">{select}</div>}
      <div className="finding-card__body">
        <div className="finding-card__meta">
          <StatusBadge status={finding.status} needsReview={finding.needsReview} />
          <span className="finding-card__version">Version {finding.version}</span>
        </div>
        <Heading className="finding-card__title">
          <Link to={findingPath(finding.id)}>{finding.title}</Link>
        </Heading>
        <p className="finding-card__summary">{finding.summary}</p>
        <EvidenceTallyLine evidence={finding.evidence} />
        <p className="finding-card__foot">
          {projectTitle !== undefined && <span>{projectTitle}</span>}
          {finding.themes.length > 0 && <span>{finding.themes.map(themeLabel).join(' · ')}</span>}
          <span>Sources to {formatDate(finding.sourceCutoff)}</span>
        </p>
      </div>
    </article>
  );
}
